// extracted by mini-css-extract-plugin
export default {"customHeaderLabelClass":"CriteriaRubricAssessmentWrapper__customHeaderLabelClass___egWyU","skeleton-loading":"CriteriaRubricAssessmentWrapper__skeleton-loading___DIVCj"};